module.exports = __webpack_public_path__ + "static/30-5e74804bebd3f42828b0c124525c36df.png";